import {call, put, select} from 'redux-saga/effects'
import {delay} from 'redux-saga'
import {loadSuccess, loadWaiting, setClinics, SUBMIT, submitFailure, submitSuccess, submitWaiting} from "./actions";
import {StripeCheckout} from "../services";
import {sendToServer} from "../utils/sagas";

function* saga(stripe = StripeCheckout.instance()) {
    let timeout = 1000;
    while (true) {
        try {
            yield put(loadWaiting());
            let response = yield call(fetch, '/api/siv-clinics');
            if (response.ok) {
                const clinics = yield call([response, response.json]);
                yield put(setClinics(clinics));
                yield put(loadSuccess());
                break;
            } else {
                throw new Error(response);
            }
        } catch (error) {
            yield call(delay, timeout *= 2);
        }
    }

    yield* sendToServer({
        EVENT: SUBMIT,
        request: function* () {
            const registration = yield select(state => state.clinics.registration);
            const token = yield call([stripe, stripe.createChargeToken], {
                name:        'Paraglide Utah, LLC',
                description: `SIV: ${registration.clinic.date} ${registration.clinic.place}`,
                amount:      registration.clinic.price * 100,
                email:       registration.email
            });
            return {
                url:  `/api/siv-clinics/${registration.clinic.id}/register`,
                data: {
                    name:    registration.name,
                    phone:   registration.phone,
                    email:   registration.email,
                    message: registration.message,
                    donesiv: (registration.donesiv && 'done siv') || 'first time',
                    token
                }
            };
        },
        waiting: submitWaiting,
        success: submitSuccess,
        failure: submitFailure
    });
}

export default saga;



// WEBPACK FOOTER //
// ./src/app/clinics/sagas.js